"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const lodash_1 = require("lodash");
const formik_1 = require("formik");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Portal_1 = __importDefault(require("@material-ui/core/Portal"));
const selector_1 = require("./selectors/selector");
const subscriber_1 = require("./selectors/subscriber");
const subscription_context_1 = require("./selectors/subscription-context");
const form_context_1 = require("./form-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const form_styles_1 = require("./form-styles");
const form_anchor_context_1 = require("./form-anchor-context");
const form_field_context_1 = require("./fields/form-field-context");
const form_submit_button_1 = require("./fields/form-submit-button");
// eslint-disable-next-line react/display-name
exports.Form = react_1.memo(react_1.forwardRef(function Form(props, ref) {
    const formId = react_1.useRef(uuid_1.v4());
    const propsRef = react_1.useRef();
    const [errors, setErrors] = react_1.useState([]);
    const { formAnchorRef } = react_1.useContext(form_anchor_context_1.FormAnchorContext);
    const validateForm = event_callback_hook_1.useEventCallback(async (customSchema) => {
        const values = propsRef.current.values;
        const schema = customSchema !== null && customSchema !== void 0 ? customSchema : props.validationSchema;
        try {
            await (schema === null || schema === void 0 ? void 0 : schema.validate(values, {
                abortEarly: false,
                context: {
                    values: values,
                },
            }));
            setErrors([]);
        }
        catch (e) {
            const yupErrors = formik_1.yupToFormErrors(e);
            const flattenedErrors = flattenObject(yupErrors);
            const errors = Object.keys(flattenedErrors).map((key) => {
                const value = flattenedErrors[key];
                return {
                    key,
                    value,
                };
            });
            setErrors(errors);
            console.log({ errors });
            return errors;
        }
        return [];
    });
    const resetValidation = event_callback_hook_1.useEventCallback(() => {
        setErrors([]);
    });
    const context = react_1.useMemo(() => {
        return {
            formId: formId.current,
            editing: props.editing,
            errors,
            setErrors,
            getFieldValues: () => propsRef.current.values,
            setFieldValues: (values) => propsRef.current.setValues(values),
            setFieldValue: (name, value) => propsRef.current.setFieldValue(name, value),
            submitForm: () => propsRef.current.submitForm(),
            clearForm: () => { var _a; return (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.resetForm(); },
            validateForm,
            resetValidation,
        };
    }, [props.editing, validateForm, resetValidation, errors]);
    react_1.useImperativeHandle(ref, () => context, [context]);
    const { subscriptionContext, fireSubscriptions } = selector_1.useSubscriptionContext(context.getFieldValues);
    const classes = form_styles_1.useStyles();
    return (react_1.default.createElement(formik_1.Formik, { initialValues: props.initialValues, onSubmit: props.onSubmit }, (formikProps) => {
        propsRef.current = formikProps;
        return (react_1.default.createElement(form_field_context_1.FormFieldContext.Provider, { value: { prefix: undefined } },
            react_1.default.createElement(form_context_1.FormContext.Provider, { value: context },
                react_1.default.createElement(subscription_context_1.SubscriptionContext.Provider, { value: subscriptionContext },
                    react_1.default.createElement(subscriber_1.Subscriber, { fireSubscriptions: fireSubscriptions }),
                    react_1.default.createElement(Portal_1.default, { container: formAnchorRef.current },
                        react_1.default.createElement("form", { id: formId.current, action: props.action, method: props.method, onReset: formikProps.handleReset, onSubmit: props.browserSubmit
                                ? undefined
                                : formikProps.handleSubmit })),
                    react_1.default.createElement("div", { className: classes.form, "data-cy": "EAS__FORM" },
                        react_1.default.createElement(Grid_1.default, { container: true, spacing: 0 }, lodash_1.isFunction(props.children)
                            ? props.children({
                                ...formikProps,
                                formId: formId.current,
                            })
                            : props.children),
                        react_1.default.createElement(form_submit_button_1.FormSubmitButton, { type: "submit", style: {
                                display: 'none',
                            } }))))));
    }));
}));
/**
 * Deep flatten object, creating chained keys with dot.
 *
 * @param obj Object to flatten
 * @param path Current path in recursion
 */
function flattenObject(obj, path = []) {
    if (typeof obj === 'string') {
        return { [path.join('.')]: obj };
    }
    else {
        return lodash_1.reduce(obj, (cum, next, key) => lodash_1.merge(cum, flattenObject(next, [...path, key])), {});
    }
}
//# sourceMappingURL=form.js.map